/**
 * The mark that stands for "Favoriter", wherever it is drawn.
 *
 * Shared rather than redeclared per feature: the header's mobile link and the
 * product card's save button had drifted to two different marks — a heart in
 * the header, the canvas's bookmark on the cards — which read as two different
 * features rather than one list at two sizes. One definition, one drift.
 *
 * The heart is kept because "Önskelista" is still reachable under that name in
 * places, but the redesign's mark is the bookmark and nothing asks for a heart
 * now.
 */

interface MarkProps {
  /** Solid once the product is on the list; outline while it is not. */
  filled?: boolean;
  /** Size and colour, e.g. `h-5 w-5`. */
  className?: string;
}

/** The canvas's bookmark: a ribbon notched at the bottom. */
export function WishlistBookmarkIcon({ filled = false, className }: MarkProps) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill={filled ? 'currentColor' : 'none'}
      stroke="currentColor"
      strokeWidth={1.6}
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M6.75 3.75h10.5a.75.75 0 01.75.75v15.75L12 16.5l-6 3.75V4.5a.75.75 0 01.75-.75z"
      />
    </svg>
  );
}

export function WishlistHeartIcon({ filled = false, className }: MarkProps) {
  if (filled) {
    return (
      <svg
        className={className}
        fill="currentColor"
        viewBox="0 0 24 24"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M11.645 20.91l-.007-.003-.022-.012a15.247 15.247 0 01-.383-.218 25.18 25.18 0 01-4.244-3.17C4.688 15.36 2.25 12.174 2.25 8.25 2.25 5.322 4.714 3 7.688 3A5.5 5.5 0 0112 5.052 5.5 5.5 0 0116.313 3c2.973 0 5.437 2.322 5.437 5.25 0 3.925-2.438 7.111-4.739 9.256a25.175 25.175 0 01-4.244 3.17 15.247 15.247 0 01-.383.219l-.022.012-.007.004-.003.001a.752.752 0 01-.704 0l-.003-.001z" />
      </svg>
    );
  }

  return (
    <svg
      className={className}
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      viewBox="0 0 24 24"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z"
      />
    </svg>
  );
}
